var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"flex-fill mx-3",attrs:{"title":_vm.title}},[_c('b-card-text',[_c('span',[_vm._v(_vm._s(_vm.referrals)+" / "+_vm._s(_vm.activeReferrals))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }